import { observer } from 'mobx-react-lite';

import { Icons } from '@/assets/icons/icons';
import { DropdownMenu } from '@/components/ui/dropdown-menu';
import { Switch } from '@/components/ui/Switch';
import { chatEngineStore } from '@/features/chat/chat-engine.store';
import { userStore } from '@/stores/user.store';

type ChatEngineMenuItemProps = {
  draftId: string;
};

export const ChatEngineMenuItem = observer(function ChatEngineMenuItem({
  draftId,
}: ChatEngineMenuItemProps) {
  if (!userStore.isInternalUser) return null;

  const runsOnV5 = chatEngineStore.engineByChat[draftId] === 'v5';

  return (
    <DropdownMenu.Item
      role="menuitemcheckbox"
      aria-checked={runsOnV5}
      onSelect={(event) => {
        // Keep the menu open so the switch visibly flips
        event.preventDefault();
        chatEngineStore.set(draftId, runsOnV5 ? 'v4' : 'v5');
      }}
    >
      <Icons.flask className="opacity-75" />
      <span className="flex-1">chat_v5 API (Pi Harness)</span>
      {/* The row handles the toggle, so the switch only shows its state */}
      <Switch
        checked={runsOnV5}
        tabIndex={-1}
        aria-hidden
        className="pointer-events-none"
      />
    </DropdownMenu.Item>
  );
});
